import axios from "axios";
import { IAdminUserListRequest, INeedsApprovalCountResponse } from "../types/XSifterApiRequestTypes";
import { IXSifterEditingUser, IXSifterUserListing } from "../types/XSifterAppUser";
import { patch } from "@mui/material";

export const XSIFTER_GET_COUNT_USERS_APPROVAL = process.env.XSIFTER_BACKEND + "/admin/needsApprovalCount";
export const XSIFTER_ADMIN_GET_USER_LIST = process.env.XSIFTER_BACKEND + "/admin/users";

export default class AdminApiService {
    public async getNumNeedingApproval(token: string): Promise<INeedsApprovalCountResponse> {
        return new Promise<INeedsApprovalCountResponse>((resolve, reject) => {
            axios.get(XSIFTER_GET_COUNT_USERS_APPROVAL, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            }).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    public async getUserList(token: string, request: IAdminUserListRequest): Promise<IXSifterUserListing> {
        return new Promise<IXSifterUserListing>((resolve, reject) => {
            const queryParams = {};
            if (request.offset)
                queryParams["offset"] = request.offset;
            if (request.limit)
                queryParams["limit"] = request.limit;
            if (request.query)
                queryParams["q"] = request.query;
            if (request.adminOnly)
                queryParams["admin"] = "true";
            if (request.disabledOnly)
                queryParams["disabled"] = "true";
            if (request.isNotApproved)
                queryParams["approval"] = "false";
            if (request.sortField)
                queryParams["sort"] = `${request.sortField}:${request.sortDirection ?? "d"}`;

            axios.get(XSIFTER_ADMIN_GET_USER_LIST, {
                params: queryParams,
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            }).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            })
        })
    }

    public async approveUser(token: string, userId: number): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const url = process.env.XSIFTER_BACKEND + `/admin/users/${userId}/approve`;
            axios.post(url, null, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            }).then((response) => {
                if (response.status === 200) {
                    resolve(true);
                } else {
                    reject(false);
                }
            }).catch((error) => {
                reject(false);
            })
        });
    }

    public async getUserInfo(token: string, userId: number):  Promise<IXSifterEditingUser | undefined> {
        return new Promise<IXSifterEditingUser | undefined>((resolve, reject) => {
            const url = process.env.XSIFTER_BACKEND + `/admin/users/${userId}`;
            axios.get(url, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            }).then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(undefined);
                }
            }).catch((error) => {
                reject(undefined);
            });
        });
    }

    public async updateUser(token: string, userId: number, patchList: any[]): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const url = process.env.XSIFTER_BACKEND + `/admin/users/${userId}`;
            axios.patch(url, patchList, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            }).then((response) => {
                if (response.status === 200) {
                    resolve(true);
                } else {
                    reject(false);
                }
            }).catch((error) => {
                reject(false);
            });
        });
    }

    public async addCreditsForUser(token: string, userId: number, creditAmount: number): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const url = process.env.XSIFTER_BACKEND + `/admin/users/${userId}/credits`;
            axios.post(url, {}, {
                params: {
                    creditAmount: creditAmount
                },
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            }).then((response) => {
                if (response.status === 200)
                    resolve(true);
                else
                    reject(false);
            }).catch((error) => {
                reject(false);
            })
        });
    }

};
